import {CreateKycContextWrapper} from "../../context/create-kyc/context-wrapper";
import {CreateKycMultiStepForm} from "../form";

export function CreateKycMultiFormStepWrapper() {
  return (
    <CreateKycContextWrapper>
      <CreateKycMultiStepForm />
    </CreateKycContextWrapper>
  );
}
